import { render, staticRenderFns } from "./repository-list.vue?vue&type=template&id=0e3d4dce&"
import script from "./repository-list.vue?vue&type=script&lang=js&"
export * from "./repository-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports